<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
     
        <el-breadcrumb-item  v-for="(item, index) in mylist" :key="index" :to="{path:item.path}">{{ item.name }}</el-breadcrumb-item>
     
    </el-breadcrumb>
  </div>
</template>
<style lang="scss">
</style>
<script>
import heardTitles from "../assets/heardTitles.js";
export default {
  name: "Bread",
  components: {},
  props:{
    list: {
      type: Array,
      default() {
        return []
      }}

  },
  data() {
    return {
      mylist:[],
      titles:heardTitles
    };
  },
  created() {
    //如果没有传 list，则根据heard组件的菜单层级，显示面包屑层级，赋值给list。根据当前页面的path查询路径。
    if(this.list.length!=0){
      this.mylist=this.list
    }else{
      // let element={}
      for (let index = 0; index < this.titles.length; index++) {
        const item = this.titles[index];
        if(item.children && item.children.length>0){
          for (let j = 0; j < item.children.length; j++) {
            const itemJ = item.children[j];
            if(itemJ.path==this.$route.path){
              this.mylist.push(itemJ)
              return
            }
          }
        }
      }
      // let item={path: this.titles.find(it=>it.) this.$route.path,name:this.$route.name}
      
    }
  },
  mounted() {},
  // 其他页面进来时更新初始数据
  activated() {},
  methods: {

  },
};
</script>
